import { Attr, BelongsTo, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";
import type { Nullable } from "shared/types";

import type Organisation from "./Organisation";
import type SocialEngagePostIntegrationEngagement from "./SocialEngagePostIntegrationEngagement";

@Model()
class SocialEngagePostsIntegration extends ApplicationRecord {
  static jsonapiType = "social_engage_posts_integrations";

  @Attr({ persist: false }) archived: boolean;

  @Attr({ persist: false }) archivedAt: string;

  @Attr() attachmentAltTexts: Nullable<Record<string, string>>;

  @Attr() deletedAt: string;

  @Attr({ persist: false }) expiresAt: Nullable<string>;

  @Attr() label: string;

  @HasOne() latestEngagement: SocialEngagePostIntegrationEngagement;

  @Attr() live: boolean;

  @Attr({ persist: false }) metadata: Record<string, any>;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() organisationSocialIntegrationId: number;

  @Attr() permalink: string;

  @Attr() postedAt: string;

  @Attr() remoteId: string;

  @Attr() scheduledAt: string;

  @Attr({ persist: false }) socialPlatform: string;

  @Attr() token: string;

  @Attr({ persist: false }) tokenRefreshedAt: string;

  @Attr({ persist: false }) updatedAt: string;

  platformIcon(whiteIcon = false) {
    if (this.socialPlatform === "TwitterSocialIntegration") {
      return `https://assets.streem.com.au/icons/twitter.svg`;
    }

    const format = whiteIcon ? "15x15" : "";

    switch (this.socialPlatform) {
      case "FacebookSocialIntegration":
        return `https://assets.streem.com.au/icons/facebook${format}.svg`;
      case "InstagramSocialIntegration":
        return `https://assets.streem.com.au/icons/instagram${format}.svg`;
      case "LinkedinSocialIntegration":
        return `https://assets.streem.com.au/icons/linkedin${format}.svg`;
      case "TiktokSocialIntegration":
        return `https://assets.streem.com.au/icons/tiktok${format}.svg`;
      default:
        return "";
    }
  }
}

export default SocialEngagePostsIntegration;
